import { Spinner } from "@/components/ui/spinner";
import { environment } from "@/config/env";
import {
  useEliteReservation,
  useEliteStructure,
} from "@/contexts/EliteTemporaryContextProvider";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Login() {
  const { setReservation } = useEliteReservation();
  const { setStructureData, setLabelTranslationService } = useEliteStructure();
  useDocumentTitle("Accesso Ospite");

  const routeParams = useParams<{ token: string; structureId: string }>();
  const routeQuery = new URLSearchParams(window.location.search);
  const fromKiosk = routeQuery.get("fromKiosk") === "true";
  const navigate = useNavigate();

  useEffect(() => {
    const token = routeParams.token;

    if (!token) {
      navigate("/error", { replace: true });
      return;
    }

    axios.defaults.baseURL = environment.ELITE_BASE_URI;
    axios.defaults.headers.common[`x-auth-key`] = token;
    sessionStorage.setItem("webcheckin_token", token);

    axios
      .get(`webcheckin/data`)
      .then((response) => {
        const {
          reservationData,
          structureContextData,
          labelTranslationService,
        } = response.data;

        setReservation(reservationData, fromKiosk, token);
        setStructureData(structureContextData);
        if (labelTranslationService) {
          setLabelTranslationService(labelTranslationService);
        }

        const rooms = reservationData?.reservation?.rooms || [];
        const allRoomsHaveAllGuests =
          rooms.length > 0 &&
          rooms.every(
            (r: any) =>
              (r.checkedInGuests?.length || 0) >= (r.guestsNumber || 1),
          );

        if (reservationData?.isFullyCompleted && allRoomsHaveAllGuests) {
          navigate("/completed", { replace: true });
        } else {
          navigate("/check-in", { replace: true });
        }
      })
      .catch((err) => {
        navigate("/expired", { replace: true });
      });
  }, []);

  return (
    <div className="flex w-full justify-center mt-5">
      <h1 className="text-2xl uppercase font-bold flex gap-2 justify-item-center">
        <Spinner className="size-10" />
      </h1>
    </div>
  );
}
